// Generated by scripts/generate-export-to-usa-pages.mjs from U.S. Census Bureau trade data — do not edit by hand.
import type { Product } from './product-types';

// One lazy chunk per HS section, so a product page only downloads its own section's data.
export const PRODUCT_DATA: Record<string, () => Promise<Product[]>> = {
  "section-01": () => import('./data/section-01').then(m => m.PRODUCTS),
  "section-02": () => import('./data/section-02').then(m => m.PRODUCTS),
  "section-03": () => import('./data/section-03').then(m => m.PRODUCTS),
  "section-04": () => import('./data/section-04').then(m => m.PRODUCTS),
  "section-05": () => import('./data/section-05').then(m => m.PRODUCTS),
  "section-06": () => import('./data/section-06').then(m => m.PRODUCTS),
  "section-07": () => import('./data/section-07').then(m => m.PRODUCTS),
  "section-08": () => import('./data/section-08').then(m => m.PRODUCTS),
  "section-09": () => import('./data/section-09').then(m => m.PRODUCTS),
  "section-10": () => import('./data/section-10').then(m => m.PRODUCTS),
  "section-11": () => import('./data/section-11').then(m => m.PRODUCTS),
  "section-12": () => import('./data/section-12').then(m => m.PRODUCTS),
  "section-13": () => import('./data/section-13').then(m => m.PRODUCTS),
  "section-14": () => import('./data/section-14').then(m => m.PRODUCTS),
  "section-15": () => import('./data/section-15').then(m => m.PRODUCTS),
  "section-16": () => import('./data/section-16').then(m => m.PRODUCTS),
  "section-17": () => import('./data/section-17').then(m => m.PRODUCTS),
  "section-18": () => import('./data/section-18').then(m => m.PRODUCTS),
  "section-19": () => import('./data/section-19').then(m => m.PRODUCTS),
  "section-20": () => import('./data/section-20').then(m => m.PRODUCTS),
};
